"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateAstra = void 0;
const gs_1 = require("@ivanlog/gs");
class StateAstra extends gs_1.StateGS {
    get app() { return StateAstra.App; }
    get gui() { return this.app.gui; }
    constructor(title, inHistory) {
        super(title, inHistory);
    }
    lockgui(action) {
        return __awaiter(this, void 0, void 0, function* () { return this.app.gui.lockAction(action); });
    }
}
exports.StateAstra = StateAstra;
//# sourceMappingURL=StateAstra.js.map